import { SDKWeek, FootballPlayerActiveSeason } from '@pff-consumer/schema'
import { getSeasonForGrades, isNextSeasonUpcoming } from '@pff-consumer/utils'

export const getDefaultActiveSeason = (
  currentGameWeek: SDKWeek | null,
  activeSeasons: FootballPlayerActiveSeason[],
  league: string
) => {
  const currentSeason = currentGameWeek?.season
  const playerSeasons = activeSeasons?.filter(
    (season: FootballPlayerActiveSeason) => season.league === league?.toUpperCase()
  )
  const lastActiveSeason = playerSeasons?.at(0)?.season
  const isActive = currentSeason === lastActiveSeason
  const isNewSeasonUpcoming = isNextSeasonUpcoming(currentGameWeek)
  const gradesSeason = getSeasonForGrades(currentSeason, isNewSeasonUpcoming)
  const defaultActiveSeason = !isActive && lastActiveSeason ? lastActiveSeason : gradesSeason
  return defaultActiveSeason
}
